import { Paths } from '../../lib/constants/path'
import { Route } from '../../lib/types/routes'
import { ClientCheckEmailPage } from './client-check-email'
import { ClientLoginPage } from './client-login'
import ForgotPasswordPage from './forgot-password'
import LoginPage from './login'
import { PcrLoginPage } from './pcr-login'
import { ServiceProviderLoginPage } from './service-provider-login'
import StaffLoginPage from './staff-login'

const authRoutes: Route[] = [
  {
    path: Paths.AUTH_LOGIN_PAGE,
    element: <LoginPage />
  },
  {
    path: Paths.AUTH_STAFF_LOGIN_PAGE,
    element: <StaffLoginPage />
  },
  {
    path: Paths.AUTH_OL_LOGIN_PAGE,
    element: <ServiceProviderLoginPage />
  },
  {
    path: Paths.AUTH_PCR_LOGIN_PAGE,
    element: <PcrLoginPage />
  },
  {
    path: Paths.AUTH_CLIENT_LOGIN_PAGE,
    element: <ClientLoginPage />
  },
  {
    path: Paths.AUTH_FORGOT_PASSWORD_PAGE,
    element: <ForgotPasswordPage />
  },
  {
    path: Paths.AUTH_CHECK_EMAIL_PAGE,
    element: <ClientCheckEmailPage />
  }
]

export default authRoutes
